module.exports = __webpack_public_path__ + "static/media/belt-2-sm.8f7a6575.jpg";